import "../../_virtual/jsx-runtime.mjs";
import { createContext as o } from "react";
import "../../depend/classnames/index.mjs";
import "../../assets/css/globalTheme.mjs";
import "../../assets/css/themes/template/templateMap.mjs";
import "../../depend/rc-notification/es/Notifications.mjs";
import "../../depend/classnames/index2.mjs";
import "./ReoMessagePurePanel.mjs";
import "../../depend/rc-util/es/React/render.mjs";
o({
  messageApi: null,
  config: {},
  setConfig: () => null
});
//# sourceMappingURL=ReoMessage.mjs.map
